import React from 'react';
import GenericMenu from './source/GenericMenuProject';
import { SLUGS } from 'src/enum/permissions.enum';

const OUR_STORAGE_MENU_MENU = {
  storage: [
    { check: SLUGS.STORAGE.READ, to: '/storage/bldg', primary: 'Список', add: true },
  ],
  remains: [
    { check: SLUGS.STORAGE.READ, to: '/storage/report/remains', primary: 'Остатки на складе' },
  ],
  documents: [
    { check: SLUGS.STORAGE.MATERIAL.MOVE_READ, to: '/storage/doc/move/project', primary: 'Переместить на проект' },
    { check: SLUGS.STORAGE.MATERIAL.ADD_READ, to: '/storage/doc/addmaterial', primary: 'Добавить на склад' },
  ],
  inventory: [
    { check: SLUGS.STORAGE.INVENTORY.READ, to: '/inventory', primary: 'Список' },
    { check: SLUGS.STORAGE.INVENTORY.MOVE_READ, to: '/inventory/move/project', primary: 'Переместить на проект' },
  ],
}
const OUR_STORAGE_MENU_SECTIONS = {
  storage: 'Склады',
  remains: 'Отчеты',
  documents: 'Документы',
  inventory: 'Инвентарные объекты',
}
export default function OurStorageMenu(props) {
  return (
    <GenericMenu
      menuConfig={OUR_STORAGE_MENU_MENU}
      sectionsMap={OUR_STORAGE_MENU_SECTIONS}
      propsRouter={props}
    />
  );
}